import { render, staticRenderFns } from "./Beach.vue?vue&type=template&id=27721aac&scoped=true&"
import script from "./Beach.vue?vue&type=script&lang=js&"
export * from "./Beach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27721aac",
  null
  
)

export default component.exports